/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

function SEO({ description, lang, meta, title, keywords, location, image }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `,
  )

  const metaDescription = description || site.siteMetadata.description
  return (
    <>
      <Helmet
        htmlAttributes={{
          lang,
        }}
        defer={false}
        titleTemplate={`%s | ${site.siteMetadata.title}`}
        title={title}
        meta={[
          {
            name: 'keywords',
            content: keywords || 'webapp,apps,machine laerning,AI, mobile, web, development, software, automation,bot, solutions',
          },
          {
            name: 'google-site-verification',
            content: 'oV9nNLIPIjiFVXrEbM2AgY2p1q3DNBirAdYW1FFMHfA',
          },
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: `${title} | ${site.siteMetadata.title}`,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            property: `og:url`,
            content: location || `https://zaat.dev/`,
          },
          {
            property: `fb:app_id`,
            content: `1008893119554121`,
          },
          {
            property: `fb:page_id`,
            content: `1008893119554121`,
          },
          {
            property: 'og:image',
            itemprop: 'image',
            content: image === 'https://d1svfprecff8lq.cloudfront.net/desktop77.png' ? image : `https://zaat.dev${image}`,
          },
          {
            name: `twitter:card`,
            content: 'summary_large_image',
          },
          {
            name: `twitter:image`,
            content: image === 'https://d1svfprecff8lq.cloudfront.net/desktop77.png' ? image : `https://zaat.dev${image}`,
          },
          {
            name: `twitter:creator`,
            content: site.siteMetadata.author,
          },
          {
            name: `twitter:title`,
            content: `${title} | ${site.siteMetadata.title}`,
          },
          {
            name: `twitter:url`,
            content: location || `https://zaat.dev/`,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
          { name: 'robots', content: 'max-image-preview:large' },
        ].concat(meta)}
      />
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0" />
        <link
          rel="preload"
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap"
          as="style"
          onLoad="this.onload=null;this.rel='stylesheet'"
        />
        <noscript>
          {`
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap" rel="stylesheet" type="text/css" />
  `}
        </noscript>
      </Helmet>
    </>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description:
    'Zaat.dev For developing digital solution, developing webapps, tasks automation, SEO fast website, creating state of the art (AI) smart solution and more ',
  keywords: 'webapp,apps,machine laerning,AI, mobile, web, development, software, automation,bot, solutions',
  location: `https://zaat.dev/`,
  image: 'https://d1svfprecff8lq.cloudfront.net/desktop77.png',
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  keywords: PropTypes.string,
  location: PropTypes.string,
  image: PropTypes.string,
}

export default SEO
